import { Observable, Subject } from 'rxjs';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { BaseDao } from './BaseDao';
import * as semaphore from 'semaphore';
import {environment} from "../../../environments/environment";
import {Moment} from "moment-timezone";

export const DashboardReportingQueryTypes = {
  TOP_LIFT_BY_CREATIVE: 'top_lift_by_creative',
  ALL_LIFT_BY_CREATIVE: 'all_lift_by_creative',
  TRAFFIC_BY_AFFILIATE: 'traffic_by_affiliate',
  TRAFFIC_BY_SOURCE_MM: 'traffic_by_source_micro_moment',
  TRAFFIC_BY_SOURCE_NMM: 'traffic_by_source_non_micro_moment',
  MM_TIMELINE: 'mm_timeline',
  TRAFFIC_BY_TIME_OF_DAY: 'traffic_by_time_of_day',
  GGL_KEYWORDS: 'google_keywords',
  LIST_CREATIVES: 'list_creatives'
};

export interface IReportDateRange {
  start: Date|Moment;
  end: Date|Moment;
}

export interface ILiftBySpotRes {
  baseline_count: number;
  mm_count: number;
  isci: string;
  spot_length: number;
  airing_count: number;
}

export class ReportDao extends BaseDao {
  private reportDateRangeSource: Subject<IReportDateRange>;
  public reportDateRangeChange$: Observable<IReportDateRange>;
  private currentReportDateRange: IReportDateRange;

  private trinoSem;

  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.REPORT, apiHelper);
    if(environment.envName == 'prod') {
      this.trinoSem = semaphore(4);
    } else {
      this.trinoSem = semaphore(2);//Max of 2 requests at a time
    }
    this.reportDateRangeSource = new Subject<IReportDateRange>();
    this.reportDateRangeChange$ = this.reportDateRangeSource.asObservable();
  }

  public getByBrand(brandId: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/brand/' + brandId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }

  loadReportHistory(integrationId: string): Observable<any> {
    let url = this.apiHelper.getServiceName('data') + 'ReportHistorys/' + integrationId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }

  setReportDateRange(range: IReportDateRange): void {
    this.currentReportDateRange = range;
    this.reportDateRangeSource.next(range);
  }

  getReportDateRangeVal(): IReportDateRange {
    return this.currentReportDateRange;
  }

  getReportDateRangeObs(): Observable<IReportDateRange> {
    return this.reportDateRangeChange$;
  }
}
